import { FC } from "react";

import { Stack } from "@mui/material";

import { DashboardTypography } from "@/dashboard-design-system/Typography";

interface DetailRowProps {
  label: string;
  value: string;
}

export const DetailRow: FC<DetailRowProps> = ({ label, value }) => (
  <Stack spacing={0.25}>
    <DashboardTypography component="dt" variant="caption" vibe="text-neutral-moderate">
      {label}
    </DashboardTypography>
    <DashboardTypography
      component="dd"
      variant="body2"
      vibe="text-neutral-intense"
      sx={{ m: 0, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
    >
      {value}
    </DashboardTypography>
  </Stack>
);
